import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../../Button';
import MultipleOutcomesMenu from '../MultipleOutcomesMenu';

import styles from './index.styl';

const SignConsentButton = ({
  buttonAccept,
  handleAcceptConsent,
  isConsentHasMultipleOutcomes,
  isSignConsentLoading,
  titles,
}) => {
  return (
    <MultipleOutcomesMenu
      titles={titles}
      isConsentHasMultipleOutcomes={isConsentHasMultipleOutcomes}
    >
      <Button
        className={styles.acceptButton}
        onClick={handleAcceptConsent}
        border={!isSignConsentLoading}
        color="primary"
        disabled={isSignConsentLoading}
      >
        {buttonAccept}
      </Button>
    </MultipleOutcomesMenu>
  );
};

SignConsentButton.propTypes = {
  buttonAccept: PropTypes.string,
  handleAcceptConsent: PropTypes.func,
  isConsentHasMultipleOutcomes: PropTypes.bool,
  isSignConsentLoading: PropTypes.bool,
  titles: PropTypes.arrayOf(PropTypes.string),
};

export default SignConsentButton;



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/VisitConsents/ConsentDetailsPopup/SingConsentButton/index.jsx